import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import QRCode from 'qrcode.react';
import moment from "moment-timezone";
import { initCovidHistory, getCovidHistory } from '../api';
import config from '../config';
import '../styles/cardiohistory.css';
export default function CovidHistory() {
    const user = useSelector(state =>  state.user);
    const history = useHistory();
    const months = {
        0: 'January',
        1: 'February',
        2: 'March',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December'
    };
    const [testResults, setTestResults] = useState([]);
    const [dateHistory, setDateHistory] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const redirectResultPage = (result) => {
        history.push({
            pathname: '/covid/testresult',
            state: {result: result}
        });    
    };
    const handleChange = async (date) => {
        setLoading(true);
        let monthYear = date.split(",");
        let from = moment([monthYear[1], monthYear[0]]).clone().startOf('month').tz(user.timezone || config.defaultTimezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        let to = moment([monthYear[1], monthYear[0]]).clone().endOf('month').tz(user.timezone || config.defaultTimezone).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        const res = await getCovidHistory(from, to);
        let results = [];
        if(res.test_results) {
            res.test_results.forEach((element, index) => {
                let isCovid;
                if(element.covid_status) {
                    if (element.covid_status === "Negative") {
                        isCovid = false;
                    }
                    else if (element.covid_status === "Positive") {
                        isCovid = true;
                    }
    
                } else {
                    var covid = Math.round(element.covid_max*100);
                
                    if(covid>=50) {isCovid = true}
                    else if (covid>=0 && covid<50) {isCovid = false}
                    else {isCovid = null}
                }
    
                const date = moment(element.createdAt).clone().tz(user.timezone || config.defaultTimezone).format('YYYY-MM-DD');
                const time = moment(element.createdAt).clone().tz(user.timezone || config.defaultTimezone).format('hh:mm A');
    
                results.push({id: element._id, isCovid, date, time, isDemo: element.isDemo, threshold: element.threshold, probability: element.covid_max, questionnaire:element.questionnaire});
            });
            setTestResults(results);
        } else {
            setTestResults([]);
        }
        setLoading(false);
        
    };
    const initializeHistory = async () => {
        setLoading(true);
        const res = await initCovidHistory();
        if(res.dateHistory) {
            setDateHistory(res.dateHistory);
            if(res.dateHistory[0]) handleChange(res.dateHistory[0])
        } else {
            setDateHistory([]);
        }
        setLoading(false);
    };
    useEffect(() => {
        document.title = "Test History";
        initializeHistory();
    }, [])
    return (
        <div className="covid-history">
            {isLoading ? <div id="cover-spin"></div> : <></>}
            <div className='wrapper'>
                <p>Select period:</p>
                    <div className='period'>
                        <select className="form-control" onChange={(e) => handleChange(e.target.value)} data-testid="test-period">
                            {
                                dateHistory.map((test, index) => {
                                    let arrHistory = test.split(",");
                                    return (<option value={test} key={index}>{months[arrHistory[0]]} {arrHistory[1]}</option>)
                                })
                            }
                        </select>
                    </div>
                <div>
                    {
                        testResults.map((result, index) => {
                            return(
                                <div className="result-box" key={index} onClick={()=>redirectResultPage(result)}>
                                    <div className="qrcode"> 
                                        <span className={result.isCovid ? "red-line" : "green-line"}></span>
                                        <span className='bg-white'><QRCode value={config.QRcode_URL + '/covid/' + result.id} size={50} renderAs={"svg"}/></span>
                                    </div>
                                    <div className="date">
                                        <span className="font-weight-bold">
                                            {result.isCovid? <span className='text-red'>COVID-19 high risk</span>:<span className='text-green'>COVID-19 low risk</span>} 
                                        </span>
                                        <span className="time">Date & Time: <span className='font-weight-bold'>{result.date} {result.time}</span></span>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {testResults.length === 0 && <p className='no-record mt-1'>No Test Record Found </p>}
                </div>
            </div>
        </div>
    )
}